import axios from 'axios';
import { Helmet } from 'react-helmet-async';
import { Link, useNavigate } from 'react-router-dom';
import React, { useState } from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';
import { toast } from '../toasts';
import { getError } from '../utils';
import '../App.css';

export default function ResetPassword() {
	const navigate = useNavigate();
	const [email, setEmail] = useState('');
	const [loading, setLoading] = useState(false);

	const submitHandler = async (e) => {
		e.preventDefault();
		setLoading(true);
		try {
			await axios.post('/api/auth/forgotPassword', { email });
			toast.success('Te enviamos un email para restablecer tu contraseña');
			navigate('/signin');
		} catch (err) {
			toast.error(getError(err));
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className='auth-screen reset-password'>
			<Helmet>
				<title>Restablecer contraseña</title>
			</Helmet>
			<div className='auth-screen__content'>
				<Form className='auth-card' onSubmit={submitHandler}>
					<h2 className='auth-card__title'>Restablecer contraseña</h2>

					<Form.Group className='auth-field' controlId='reset-email'>
						<Form.Label>E-mail</Form.Label>
						<Form.Control
							className='auth-input'
							type='email'
							placeholder='nombre@empresa.com'
							value={email}
							onChange={(e) => setEmail(e.target.value.toLowerCase())}
							required
						/>
					</Form.Group>

					<Button className='auth-submit' type='submit' disabled={loading}>
						{loading ? (
							<>
								<Spinner animation='border' size='sm' className='me-1' />
								Enviando...
							</>
						) : (
							'Enviar email'
						)}
					</Button>

					<p className='auth-card__switch'>
						<Link to='/signin'>Volver a iniciar sesión</Link>
					</p>
				</Form>
			</div>
		</div>
	);
}
